import { render, staticRenderFns } from "./UmkmBermitraMainCarousel.vue?vue&type=template&id=6c86aed8&scoped=true"
import script from "./UmkmBermitraMainCarousel.vue?vue&type=script&lang=js"
export * from "./UmkmBermitraMainCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c86aed8",
  null
  
)

export default component.exports